import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/ProductDetailsModal';

export const PRODUCT_DETAILS_MODAL_VIEW = `${rootActionPath}/VIEW`;
export const PRODUCT_DETAILS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const PRODUCT_DETAILS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
export const PRODUCT_DETAILS_MODAL_CLEAR = `${rootActionPath}/CLEAR`;
